import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=4c8f8d17&"
import script from "./HomeBanner.vue?vue&type=script&lang=ts&"
export * from "./HomeBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports